/**  水印添加方法  */

let setWatermark = (str1, str2, str3, str4) => {
  let id = '1.23452384164.123412415'

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }

  let can = document.createElement('canvas')
  // 设置canvas画布大小
  can.width = 275
  can.height = 200

  let cans = can.getContext('2d')
  cans.rotate(-20 * Math.PI / 180) // 水印旋转角度
  cans.font = '15px Vedana'
  cans.fillStyle = '#d6d5d5'
  cans.textAlign = 'center'
  cans.textBaseline = 'Middle'
  cans.fillText(str1, can.width / 2, can.height / 2) // 水印在画布的位置x，y轴
  cans.fillText(str2, can.width / 2, can.height / 2 + 22)
  cans.fillStyle = '#f00707'
  cans.fillText(str3, can.width / 2, can.height / 2 + 44)
  cans.fillText(str4, can.width / 2, can.height / 2 + 66)

  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '40px'
  div.style.left = '0px'
  div.style.opacity = '0.3'
  div.style.position = 'fixed'
  div.style.zIndex = '100000'
  div.style.width = document.documentElement.clientWidth + 'px'
  div.style.height = document.documentElement.clientHeight + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}

// 添加水印方法
export const setWaterMark = (str1, str2, str3, str4) => {
  let id = setWatermark(str1, str2, str3, str4)
  if (document.getElementById(id) === null) {
    id = setWatermark(str1, str2, str3, str4)
  }
}

// 移除水印方法
export const removeWatermark = () => {
  let id = '1.23452384164.123412415'
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }
}




// WEBPACK FOOTER //
// ./src/utils/water_mark.js